import { render, staticRenderFns } from "./PremiumCoupon.vue?vue&type=template&id=7c2ccb21&scoped=true"
import script from "./PremiumCoupon.vue?vue&type=script&lang=js"
export * from "./PremiumCoupon.vue?vue&type=script&lang=js"
import style0 from "./PremiumCoupon.vue?vue&type=style&index=0&id=7c2ccb21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ccb21",
  null
  
)

export default component.exports